import React from "react"
import { ensureArray } from "lib/ensure-array"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Else } from "lib/@components/else"

export function If({ value, truthy, field, children, equals, not, ...props }) {
    props.then = props.then || children || []
    const { target, ...contextProps } = useBoundContext()
    const targetValue = Object.get(target, field) ?? Object.get(contextProps, field)
    value = value ?? truthy ?? targetValue
    props.then = React.Children.map(props.then, (v, i) => {
        if (!!v && typeof v === "object") {
            return <v.type {...v.props} key={v.key ?? i} />
        } else {
            return v
        }
    })
    props.else ??= [props.then.find((c) => c?.type === Else)].filter(Boolean)
    props.then = ensureArray(props.then).filter((c) => c?.type !== Else && c?.type?.name !== "Else")

    const condition = equals ? value === equals : !!value
    // eslint-disable-next-line no-nested-ternary
    return not
        ? !condition
            ? props.then || null
            : props.else || null
        : condition
          ? props.then || null
          : props.else || null
}
